<p-panel>
    <app-reactive-form-builder
      #formbuilder
      (formChanges)="formChanges($event[0], $event[1])"
      (goBack)="goBack()"
      (afterSend)="undefined"
      [form]="form.formFields"
      [serverUrl]="''"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [id]="getModel().id"
      [request]="getType() === formTypes.EDITION ? fincasApi.fincasPUT : fincasApi.fincasPOST"
      [getRequest]="fincasApi.fincasGET">
    </app-reactive-form-builder>
</p-panel>

@if (showReaImportDialog) {
  <app-rea-import-modal
    [visible]="showReaImportDialog"
    (visibleChange)="onReaDialogVisibilityChange($event)"
    [model]="buildReaModalModel()"
    (imported)="onReaImported($event)">
  </app-rea-import-modal>
}